export default (init, mode) => {
  const $window = $(window);
  const desktopWidth = 960;
  const tabItem = $(".tab_content__item");
  const firstTabItem = $(".tab_content__item:first");
  const firstTabList = $(".tabs-list__item:first");
  const tabListItem = $(".tabs-list__item");

  const shownMobileAccordion = () => {
    if ($window.width() < desktopWidth) {
      tabItem.show();
      tabItem.hide();
      tabItem.addClass("is-active");
      firstTabItem.show();
      firstTabList.addClass("is-active");
    } else {
      tabItem.show();
      tabItem.hide();
      tabItem.addClass("is-active");
      firstTabItem.show();
      firstTabList.addClass("is-active");
    }
  }

  shownMobileAccordion();

  firstTabItem.attr("aria-hidden", "false");
  firstTabList.attr("aria-selected", "true");

  tabListItem.on("keyup", function(e) {
    if (e.key !== "Tab") return;

    tabItem.hide();
    tabItem.attr("aria-hidden", "true");

    const activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    $("#"+activeTab).attr("aria-hidden", "false");

    tabListItem.removeClass("is-active");
    tabListItem.attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
  });

  tabListItem.on("click", function(e) {
    tabItem.hide();
    tabItem.attr("aria-hidden", "true");

    const activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();
    $("#"+activeTab).attr("aria-hidden", "false");

    tabListItem.removeClass("is-active");
    tabListItem.attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
  });

  const panelTitle = $(".tab__title");
  const visibilityMode = mode || "single";
  const isInitialized = init || "init";
  const transitionTime = 170;

  if (isInitialized === "init") {
    const hidePanels = () => {
      const activeTitles = panelTitle.filter(function() {
        return $(this).attr("aria-selected") === "true";
      });

      $.each(activeTitles, function() {
        $(this).attr("aria-selected", "false");
        $(this)
          .next()
          .slideUp(transitionTime);
      });
    }

    $.each(panelTitle, function() {
      const isOpen = $(this).attr("aria-selected");

      if (isOpen === "true") {
        $(this)
          .next()
          .slideDown(transitionTime);
      } else {
        $(this)
          .next()
          .slideUp(transitionTime);
      }
    });

    if (visibilityMode === "single") {
      panelTitle.on("click", function() {
        const title = $(this);
        const panel = $(this).next();

        if (panel.length) {
          if (panel.is(":visible")) {
            $.each(panelTitle, function() {
              hidePanels();
            });
          } else {
            hidePanels();
            title.attr("aria-selected", "true");
            panel.slideDown(transitionTime);
          }
        }
      });
    } else if (visibilityMode === "multiply") {
      panelTitle.on("click", function() {
        const panel = $(this).next();

        if (panel.length) {
          panel.slideDown(transitionTime);
        } else {
          panel.slideUp(transitionTime);
        }
      });
    }
  } else {
    $(panelTitle).unbind("click");
  }
};
